<script>
export default {
	name: "logout",
	data() {
		return {};
	},
	created() {
		// this.findAll();
	},
	mounted() {
		this.$store.dispatch("auth/logout", this.user).then(() => {
			this.$router.push("/login");
		});
	},
};
</script>

<template>
	<div>
		<Breadcrumbs title="Logout" />
	</div>
</template>